import { render, staticRenderFns } from "./VInfo.vue?vue&type=template&id=048b6142&"
import script from "./VInfo.vue?vue&type=script&lang=js&"
export * from "./VInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports